module.exports = __webpack_public_path__ + "static/media/delete.c570b521.png";